import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-windows",
  "use": "icon-windows-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-windows\"><path d=\"M527.27555161 96.97103013v373.99210667h494.51361975V15.02675753zM527.27555161 928.32350815l494.51361975 80.52028049v-455.67747161h-494.51361975zM4.67045136 470.83368297H422.67685925V110.56368197l-418.00640789 69.25779753zM4.67045136 846.76759703L422.67685925 914.86031013V553.16631703H4.67045136z\" p-id=\"1287\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol